import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL, CURRENCY_NOTE } from './CtaButton';
import { trackCheckoutStart } from '../lib/metaPixel';

/**
 * Discreet mobile-only checkout bar. Appears once the hero CTA has scrolled
 * out of view and hides again whenever another CTA is on screen, so two
 * buttons never compete.
 */
export function StickyCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero-cta');
    const offer = document.getElementById('offer');
    if (!hero) return;
    const state = {
      heroVisible: true,
      offerVisible: false
    };
    const sync = () => setIsVisible(!state.heroVisible && !state.offerVisible);
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) state.heroVisible = entry.isIntersecting;
        if (entry.target === offer) state.offerVisible = entry.isIntersecting;
      });
      sync();
    }, {
      rootMargin: '-8% 0px -8% 0px'
    });
    observer.observe(hero);
    if (offer) observer.observe(offer);
    return () => observer.disconnect();
  }, []);
  return;
}